import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HTMLAttributes } from "react";

import { MinPrice } from "../components/MinPrice";
import { Price as PriceType } from "../types/Price";
import { Wrapper, TitleWrapper } from "./ProductHeaderLayoutComponents";

export type ProductHeaderProps = {
    title: string;
    minPrice?: PriceType;
} & HTMLAttributes<HTMLDivElement>;

const Title = styled(Typography)(({ theme }) => ({
    "&": {
        fontSize: 34,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        [theme.breakpoints.down("lg")]: {
            fontSize: 24,
            WebkitLineClamp: 4,
        },
    },
}));

const Price = styled(MinPrice)(({ theme }) => ({
    gridArea: "price",
    alignSelf: "end",
    [theme.breakpoints.down("lg")]: {
        alignSelf: "start",
    },
}));

export function ProductHeader({ title, minPrice, ...props }: ProductHeaderProps) {
    return (
        <Wrapper {...props}>
            <TitleWrapper>
                <Title variant="h1" p={0}>
                    {title}
                </Title>
            </TitleWrapper>
            {minPrice && <Price size="large" amount={minPrice.amount} currency={minPrice.currency} />}
        </Wrapper>
    );
}
